var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C2.46265 0 0 2.46353 0 5.5C0 8.53824 2.46265 11 5.5 11C8.53735 11 11 8.53824 11 5.5C11 2.46353 8.53735 0 5.5 0ZM5.5 2.43952C6.01443 2.43952 6.43145 2.85654 6.43145 3.37097C6.43145 3.8854 6.01443 4.30242 5.5 4.30242C4.98557 4.30242 4.56855 3.8854 4.56855 3.37097C4.56855 2.85654 4.98557 2.43952 5.5 2.43952ZM6.74194 8.07258C6.74194 8.21955 6.62278 8.33871 6.47581 8.33871H4.52419C4.37722 8.33871 4.25806 8.21955 4.25806 8.07258V7.54032C4.25806 7.39335 4.37722 7.27419 4.52419 7.27419H4.79032V5.85484H4.52419C4.37722 5.85484 4.25806 5.73568 4.25806 5.58871V5.05645C4.25806 4.90948 4.37722 4.79032 4.52419 4.79032H5.94355C6.09052 4.79032 6.20968 4.90948 6.20968 5.05645V7.27419H6.47581C6.62278 7.27419 6.74194 7.39335 6.74194 7.54032V8.07258Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcon);
export default __webpack_public_path__ + "static/media/CircleIcon.4b6a84759317cedc77157564ca3484e0.svg";
export { ForwardRef as ReactComponent };